import styled from "styled-components";
import { Table } from "react-bootstrap";

/**
 * Shared styled components for Triple Barrel Cash Blast promotional pages
 * These components are used across multiple TBCB pages to maintain consistency
 */

export const PrizeTablesTitleBar = styled.div`
  background: linear-gradient(180deg, #9a6a29 0%, #d5a64a 100%);
  padding: 0.5rem 2rem;
  margin: 1rem 0 0 0;
  width: 100%;

  h2 {
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    margin: 0;
    text-align: center;
    font-size: 2.5rem;
    letter-spacing: 1px;
  }

  @media (max-width: 768px) {
    margin: 2rem 0;
    width: 100%;
    padding: 0.5rem;
    h2 {
      font-size: 1.2rem;
    }
  }
`;

export const PrizeTablesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto auto;
  column-gap: 20px;
  row-gap: 0;
  margin: 20px 0;

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const BackgroundWrapper = styled.div`
  background: url(${(props) => props.bgImage}) center/100% 100% no-repeat;
  padding: 20px;
  z-index: 0;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const TableContainer = styled.div`
  z-index: 1;
  position: relative;
  padding: 20px 20px 0;

  @media (max-width: 767px) {
    background: url(${(props) => props.bgImage || ""}) center/100% 100%
      no-repeat;
    padding: 20px 0 0;
  }
`;

export const StyledTable = styled(Table)`
  width: 100%;
  position: relative;
  border: none !important;
  border-collapse: collapse;
  border-spacing: 0;
  background: transparent !important;

  tbody {
    background: transparent !important;
  }

  thead,
  th,
  td {
    border: none !important;
    background: transparent !important;
    strong {
      color: white;
    }
    p {
      margin: 0;
    }
  }
  img {
    margin: 2px 0 6px 0;
    max-height: 32px;
    width: 100%;
  }
  .diamond > img {
    margin: -6px 0;
    max-height: 52px;
    width: 100%;
  }
  th {
    vertical-align: middle;
    max-height: 40px;
    width: 100%;
  }
  tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  thead tr:first-child th {
    padding: 0 0 1rem 0;
  }

  thead tr:nth-child(2) th {
    font-weight: 700;
    color: #fff;
    background: linear-gradient(180deg, #9a6a29 0%, #d5a64a 100%) !important;
    position: relative;

    &:not(:last-child)::after {
      content: "|";
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      color: #fff;
      font-weight: bold;
      font-size: 1.2rem;
    }
  }

  tbody tr:first-child td {
    padding-top: 1rem;
  }

  tbody tr:not(:last-child) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
`;

export const DrawTimesContainer = styled.div`
  z-index: 1;
  position: relative;
  text-align: center;
  padding: 1rem 20px;
  background: #0000003d;

  p {
    margin: 0;
    strong {
      color: #d59947;
    }
  }

  @media (max-width: 767px) {
    margin-bottom: 20px;
    margin-top: -20px;
  }
`;

export const ListText = styled.div`
  ul {
    width: fit-content;
    margin: 0 auto;
  }
`;

export const DrawDatesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media (max-width: 555px) {
    flex-direction: column;
  }
  > p {
    margin: 1rem;
    padding: 1rem;
    border: solid 2px #a56e27;
    strong {
      display: block;
      font-size: 1.5rem;
    }
  }
`;

// Bootstrap-specific styled table for 2025 page
export const BootstrapTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const BootstrapStyledTable = styled(Table)`
  width: 100%;
  margin: 20px 0;
  position: relative;
  border: none !important;
  border-collapse: collapse;
  border-spacing: 0;
  background: transparent !important;
  display: flex;
  flex-direction: column;
  flex: 1;

  thead {
    flex-shrink: 0;
  }

  tbody {
    flex: 1;
    background: url(${(props) => props.bgImage}) center/100% 100% no-repeat !important;
    min-height: 320px;
    display: flex;
    flex-direction: column;
  }

  thead,
  th,
  td {
    border: none !important;
    background: transparent !important;
    p {
      margin: 0;
    }
  }
  img {
    margin: 2px 0 6px 0;
    max-height: 32px;
    width: 100%;
  }
  .diamond > img {
    margin: 0;
    max-height: 40px;
    width: 100%;
  }
  th {
    vertical-align: middle;
  }
  tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  thead tr:first-child th {
    padding: 0 0 1rem 0;
  }

  thead tr:nth-child(2) th {
    font-weight: 700;
    color: #fff;
    background: linear-gradient(180deg, #9a6a29 0%, #d5a64a 100%) !important;
    position: relative;

    &:not(:last-child)::after {
      content: "|";
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      color: #fff;
      font-weight: bold;
      font-size: 1.2rem;
    }
  }

  tbody tr.draw-times {
    display: table;
    margin-top: auto;

    td {
      text-align: center;
      padding-top: 1rem;
      padding-bottom: 1rem;

      p {
        margin: 0;
        strong {
          color: #d59947;
        }
      }
    }
  }
`;
